import Vue from 'vue'
import Vuex from 'vuex'
import themeConfig from "@/../themeConfig.js"
import colors from "@/../themeConfig.js"


Vue.use(Vuex)


export default new Vuex.Store({
  windowBreakPoint: state => {
    if (state.windowWidth >= 1200) return "xl"
    else if (state.windowWidth >= 992) return "lg"
    else if (state.windowWidth >= 768) return "md"
    else if (state.windowWidth >= 576) return "sm"
    else return "xs"
  },
  state: {
    menulayout: themeConfig.menulayout || "vertical",
    compactsidebar: themeConfig.compactsidebar,
    theme: themeConfig.theme || "light",
    themePrimaryColor: colors.primary,
    windowWidth: null
  },
  mutations: {
    UPDATE_THEME(state, val) {
      state.theme = val
    },
    COMPACT_SIDEBAR(state, val) {
      state.compactsidebar = val
    },
    UPDATE_MENU_LAYOUT(state, val) {
      state.menulayout = val
    },
    UPDATE_WINDOW_WIDTH(state, width) {
      state.windowWidth = width
    },
    UPDATE_PRIMARY_COLOR(state, val)   { 
      state.themePrimaryColor = val 
    },
  },
  actions: {
    updateTheme({ commit }, val) {
      commit('UPDATE_THEME', val)
    }
  },
  strict: process.env.NODE_ENV !== 'production'
})
